import React, { useState } from "react";
import "./ClinicDetailsCard.css";
// import { Link } from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddSlot from "./AddSlot";
import Select from "react-select";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import AddDoctorPopup from "./AddDoctorPopup";
import AddAssistantPopup from "./AddAssistantPopup";
import { useApp } from "../../../AppProvider";
import { useAuth } from "../../../AuthProvider";
import { useMemo } from "react";
import api from "./../../../axiosInstance"
import { Alert } from "antd";
import logger from "../../../utils/logger";

const options = [
  { value: "Online", label: "Online" },
  { value: "Offline", label: "Offline" },
];

const initialAdditionalImages = [
  "https://images.pexels.com/photos/7108332/pexels-photo-7108332.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  "https://www.stinabooth.com/wp-content/uploads/2017/05/07nmcclinics-studiosb.jpg",
];

const availableAssistants = [
  {
    assistantName: "Assistant 1",
    assistantImage:
      "https://img.freepik.com/free-photo/portrait-smiling-young-man-standing-with-arms-crossed-white-background_171337-1002.jpg?w=1060",
    assistantSpecialization: "Nurse",
  }
];

const ClinicDetailsCard = () => {
  const { user } = useAuth();
  const { clinics, doctor, setDoctor, setClinics } = useApp();
  const [addSlotPopUp, setAddSlotPopUp] = useState(false);
  const [showMoreImages, setShowMoreImages] = useState(false);
  const [fullScreenImageIndex, setFullScreenImageIndex] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [additionalImages, setAdditionalImages] = useState(initialAdditionalImages);
  const [addDoctorPopup, setAddDoctorPopup] = useState(false);
  const [addAssistantPopup, setAddAssistantPopup] = useState(false);
  const [assistants, setAssistants] = useState(availableAssistants);
  const [isEditingLocation, setIsEditingLocation] = useState(false);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [isSavingContact, setIsSavingContact] = useState(false);

  const { clinicdetailscardId } = useParams()

  logger.debug(clinics.filter((s) => s._id.toString() === clinicdetailscardId))
  const selectedClinic = clinics.filter((s) => s._id.toString() === clinicdetailscardId)[0]
  const [locationInput, setLocationInput] = useState(selectedClinic?.mapsLink || '');

  const addr = selectedClinic?.contact?.address || {};
  const [editContact, setEditContact] = useState({
    email:        selectedClinic?.contact?.email?.[0] || '',
    countryCode:  selectedClinic?.contact?.phoneNumber?.countryCode || '91',
    phoneNumber:  selectedClinic?.contact?.phoneNumber?.phoneNumber || '',
    addressLine1: addr.addressLine1 || '',
    addressLine2: addr.addressLine2 || '',
    addressLine3: addr.addressLine3 || '',
    postalCode:   addr.postalCode   || '',
    city:         addr.city         || '',
    state:        addr.state        || '',
    country:      addr.country      || '',
  });

  const handleSaveContact = async () => {
    if (!/^\d{10}$/.test(editContact.phoneNumber)) {
      window.alert('Phone number must be exactly 10 digits');
      return;
    }
    setIsSavingContact(true);
    try {
      const payload = {
        contact: {
          ...selectedClinic.contact,
          email: editContact.email ? [editContact.email] : [],
          phoneNumber: {
            countryCode: editContact.countryCode || '91',
            phoneNumber: editContact.phoneNumber,
          },
          address: {
            addressLine1: editContact.addressLine1,
            addressLine2: editContact.addressLine2,
            addressLine3: editContact.addressLine3,
            postalCode:   editContact.postalCode,
            city:         editContact.city,
            state:        editContact.state,
            country:      editContact.country,
          },
        },
      };
      const { data } = await api.put(`/clinics/${selectedClinic._id}`, payload);
      setClinics(prev => prev.map(c => c._id === selectedClinic._id ? { ...c, ...data } : c));
      setIsEditingContact(false);
    } catch (e) {
      logger.error('Error updating contact info:', e);
    } finally {
      setIsSavingContact(false);
    }
  };



  const removeAvailableSlotCapsule = (slotToRemove) => {
    if (!selectedClinic || !selectedClinic.doctorTimings) return;

    const clinicId = selectedClinic._id;
    const doctorId = user._id.toString();

    // 1️⃣ Update clinics state (UI update)
    setClinics((prevClinics) =>
      prevClinics.map((clinic) => {
        if (clinic._id.toString() !== clinicId.toString()) return clinic;

        return {
          ...clinic,
          doctorTimings: clinic.doctorTimings.map((dt) => {
            if (dt.doctorId.toString() !== doctorId) return dt;

            return {
              ...dt,
              schedule: dt.schedule.filter(
                (s) =>
                  !(
                    s.day === slotToRemove.day &&
                    s.startTime.hour === slotToRemove.startTime.hour &&
                    s.startTime.minute === slotToRemove.startTime.minute &&
                    s.endTime.hour === slotToRemove.endTime.hour &&
                    s.endTime.minute === slotToRemove.endTime.minute
                  )
              ),
            };
          }),
        };
      })
    );

    // 2️⃣ Update backend (fire & forget)
    updateSlotOnServer(
      clinicId,
      doctorId,
      selectedClinic.doctorTimings
        .find((dt) => dt.doctorId.toString() === doctorId)
        ?.schedule.filter(
          (s) =>
            !(
              s.day === slotToRemove.day &&
              s.startTime.hour === slotToRemove.startTime.hour &&
              s.startTime.minute === slotToRemove.startTime.minute &&
              s.endTime.hour === slotToRemove.endTime.hour &&
              s.endTime.minute === slotToRemove.endTime.minute
            )
        )
    );
  };



  // Separated function for updating backend
  const updateSlotOnServer = async (clinicId, doctorId, schedule) => {
    try {
      const response = await api.put(`/clinics/${clinicId}`, { doctorTimings: { doctorId, schedule } })

      const result = response.data
      logger.debug('✅ Time slot updated on server:', result);
    } catch (error) {
      logger.error('❌ Error updating time slot:', error);
    }
  };




  const openFullScreenImage = (index) => {
    setFullScreenImageIndex(index);
  };

  const closeFullScreenImage = () => {
    setFullScreenImageIndex(null);
  };

  const showNextImage = () => {
    setFullScreenImageIndex(
      (prevIndex) => (prevIndex + 1) % additionalImages.length
    );
  };

  const showPreviousImage = () => {
    setFullScreenImageIndex(
      (prevIndex) => (prevIndex - 1 + additionalImages.length) % additionalImages.length
    );
  };

  const removeImage = (index) => {
    setAdditionalImages(additionalImages.filter((_, i) => i !== index));
  };

  const addImage = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAdditionalImages([...additionalImages, reader.result]);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddDoctor = (doctors) => {
    setDoctor([...doctor, doctors]);
  };



  const handleAddAssistant = (assistant) => {
    setAssistants([...assistants, assistant]);
  };

  const handleRemoveAssistant = (index) => {
    setAssistants(assistants.filter((_, i) => i !== index));
  };

  const toggleEditLocation = () => {
    setIsEditingLocation(!isEditingLocation);
  };

  const handleLocationChange = async (event) => {
    setLocationInput(event.target.value);
    try {
      const response = await api.put(`clinics/${selectedClinic._id}`, { mapsLink: event.target.value })
      Alert('Location Changed ')
    } catch (e) {
      Alert('Could not chnage location')
    }
  };

  const hashObject = (obj) => JSON.stringify(obj);
  const slotsByDay = useMemo(() => {
    logger.debug("SLOTS BY DAY IS CHANGED")
    if (!selectedClinic?.doctorTimings) return {};

    const doctorTiming = selectedClinic.doctorTimings.find(
      (obj) => obj.doctorId.toString() === user._id.toString()
    );

    if (!doctorTiming || !doctorTiming.schedule) return {};
    logger.debug("SLOTS BY DAY IS CHANGED", doctorTiming)
    const unorderedSlots = doctorTiming.schedule.reduce((acc, slot) => {
      acc[slot.day] = acc[slot.day] || [];
      acc[slot.day].push(slot);
      return acc;
    }, {});
    const daysOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const orderedSlots = {};

    daysOrder.forEach((day) => {
      if (unorderedSlots[day]) {
        orderedSlots[day] = unorderedSlots[day];
      }
    });

    return orderedSlots;
  }, [selectedClinic, user._id, hashObject(selectedClinic?.doctorTimings)]);
  logger.debug("SHEDULE = ", slotsByDay)


  return (
    <div className="clinic-details-main-container">
      <div className="doctorClinic-details-card_Container">
        <Link className="doctorClinicDetails-card-BackLink" to="/setting/doctorclinic">
          <ArrowBackIosIcon />
          <div>Go Back</div>
        </Link>
        <div className="doctorClinicDetails-logo-Header">
          <h2>{selectedClinic.name.fullName}</h2>
        </div>
        <div className="blank-section"></div>
      </div>
      <header className="header">
        <div className="main-image">
          <img
            src="https://www.yashodahealthcare.com/blogs/wp-content/uploads/2023/01/radiology-diagnostic-imaging-at-yashoda-hospital-768x512.webp"
            alt="MainProperty"
          />
        </div>
        <div className="side-images">
          <img
            src="https://www.stinabooth.com/wp-content/uploads/2017/05/07nmcclinics-studiosb.jpg"
            alt="RoomPhoto"
            onClick={() => openFullScreenImage(1)}
          />
          <img
            src="https://images.pexels.com/photos/7108332/pexels-photo-7108332.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt="GuestPhoto"
            onClick={() => openFullScreenImage(0)}
          />
        </div>
        <div className="side-images">
          <img
            src="https://www.stinabooth.com/wp-content/uploads/2017/05/07nmcclinics-studiosb.jpg"
            alt="RoomPhoto"
            onClick={() => openFullScreenImage(3)}
          />
          <div className="see-more-image-container">
            <img
              src="https://images.pexels.com/photos/7108332/pexels-photo-7108332.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="GuestPhoto"
              onClick={() => openFullScreenImage(2)}
            />
            <button
              className="see-more-button"
              onClick={() => setShowMoreImages(true)}
            >
              See More
            </button>
          </div>
        </div>
      </header>
      <div className="clinic-details-left_section-header-right">
        <div className="clinic-details_about">
          <div className="clinic-contact-header">
            <h3 className="about_Heading">Contact Info</h3>
            {!isEditingContact ? (
              <button className="clinic-contact-edit-btn" onClick={() => setIsEditingContact(true)}>
                Edit
              </button>
            ) : (
              <div className="clinic-contact-action-btns">
                <button className="clinic-contact-cancel-btn" onClick={() => setIsEditingContact(false)} disabled={isSavingContact}>
                  Cancel
                </button>
                <button className="clinic-contact-save-btn" onClick={handleSaveContact} disabled={isSavingContact}>
                  {isSavingContact ? 'Saving…' : 'Save'}
                </button>
              </div>
            )}
          </div>

          <div className="clinic-contact-grid">
            {/* Phone */}
            <div className="clinic-contact-row">
              <span className="clinic-contact-label">Phone</span>
              {isEditingContact ? (
                <div className="clinic-contact-phone-input-group">
                  <span className="clinic-contact-country-code-prefix">+</span>
                  <input
                    className="clinic-contact-input clinic-contact-country-code-input"
                    type="text"
                    placeholder="91"
                    maxLength={3}
                    value={editContact.countryCode}
                    onChange={e => setEditContact(prev => ({ ...prev, countryCode: e.target.value.replace(/\D/g, '') }))}
                  />
                  <input
                    className="clinic-contact-input"
                    type="tel"
                    placeholder="e.g. 9876543210"
                    maxLength={10}
                    value={editContact.phoneNumber}
                    onChange={e => setEditContact(prev => ({ ...prev, phoneNumber: e.target.value.replace(/\D/g, '').slice(0, 10) }))}
                  />
                </div>
              ) : (
                <span className="clinic-contact-value">
                  {selectedClinic.contact?.phoneNumber?.phoneNumber
                    ? `+${selectedClinic.contact?.phoneNumber?.countryCode || '91'} ${selectedClinic.contact.phoneNumber.phoneNumber}`
                    : '—'}
                </span>
              )}
            </div>

            {/* Email */}
            <div className="clinic-contact-row">
              <span className="clinic-contact-label">Email</span>
              {isEditingContact ? (
                <input
                  className="clinic-contact-input"
                  type="email"
                  placeholder="e.g. clinic@example.com"
                  value={editContact.email}
                  onChange={e => setEditContact(prev => ({ ...prev, email: e.target.value }))}
                />
              ) : (
                <span className="clinic-contact-value">
                  {selectedClinic.contact?.email?.[0] || '—'}
                </span>
              )}
            </div>

            {/* Address Line 1 */}
            <div className="clinic-contact-row">
              <span className="clinic-contact-label">Address Line 1</span>
              {isEditingContact ? (
                <input className="clinic-contact-input" type="text" placeholder="Building / Street"
                  value={editContact.addressLine1}
                  onChange={e => setEditContact(prev => ({ ...prev, addressLine1: e.target.value }))} />
              ) : (
                <span className="clinic-contact-value">{addr.addressLine1 || '—'}</span>
              )}
            </div>

            {/* Address Line 2 */}
            <div className="clinic-contact-row">
              <span className="clinic-contact-label">Address Line 2</span>
              {isEditingContact ? (
                <input className="clinic-contact-input" type="text" placeholder="Area / Landmark"
                  value={editContact.addressLine2}
                  onChange={e => setEditContact(prev => ({ ...prev, addressLine2: e.target.value }))} />
              ) : (
                <span className="clinic-contact-value">{addr.addressLine2 || '—'}</span>
              )}
            </div>

            {/* Address Line 3 */}
            <div className="clinic-contact-row">
              <span className="clinic-contact-label">Address Line 3</span>
              {isEditingContact ? (
                <input className="clinic-contact-input" type="text" placeholder="Near / Other details"
                  value={editContact.addressLine3}
                  onChange={e => setEditContact(prev => ({ ...prev, addressLine3: e.target.value }))} />
              ) : (
                <span className="clinic-contact-value">{addr.addressLine3 || '—'}</span>
              )}
            </div>

            {/* City + Postal Code on same row */}
            <div className="clinic-contact-row">
              <span className="clinic-contact-label">City</span>
              {isEditingContact ? (
                <input className="clinic-contact-input" type="text" placeholder="City"
                  value={editContact.city}
                  onChange={e => setEditContact(prev => ({ ...prev, city: e.target.value }))} />
              ) : (
                <span className="clinic-contact-value">{addr.city || '—'}</span>
              )}
            </div>

            <div className="clinic-contact-row">
              <span className="clinic-contact-label">Postal Code</span>
              {isEditingContact ? (
                <input className="clinic-contact-input" type="text" placeholder="e.g. 400001"
                  value={editContact.postalCode}
                  onChange={e => setEditContact(prev => ({ ...prev, postalCode: e.target.value }))} />
              ) : (
                <span className="clinic-contact-value">{addr.postalCode || '—'}</span>
              )}
            </div>

            <div className="clinic-contact-row">
              <span className="clinic-contact-label">State</span>
              {isEditingContact ? (
                <input className="clinic-contact-input" type="text" placeholder="State"
                  value={editContact.state}
                  onChange={e => setEditContact(prev => ({ ...prev, state: e.target.value }))} />
              ) : (
                <span className="clinic-contact-value">{addr.state || '—'}</span>
              )}
            </div>

            <div className="clinic-contact-row">
              <span className="clinic-contact-label">Country</span>
              {isEditingContact ? (
                <input className="clinic-contact-input" type="text" placeholder="Country"
                  value={editContact.country}
                  onChange={e => setEditContact(prev => ({ ...prev, country: e.target.value }))} />
              ) : (
                <span className="clinic-contact-value">{addr.country || '—'}</span>
              )}
            </div>
          </div>

          <div className="clinic-details_location-container">
            <div className="clinic-location-box">
              <LocationOnIcon className="clinic_location-e" />
              {isEditingLocation ? (
                <input
                  type="text"
                  value={locationInput}
                  onChange={handleLocationChange}
                  className="location-input"
                />
              ) : (
                locationInput
              )}
            </div>
            <div
              className="clinic-details_edit-on-map"
              onClick={toggleEditLocation}
            >
              {isEditingLocation ? "Save Location" : "Edit Maps Link"}
            </div>
          </div>
        </div>
        <hr className="horizintal-line-clinic-details-card" />
        <div className="clinic-details_slot-section">
          <div className="headingcontainer" onClick={() => { setAddSlotPopUp(true); }} >
            <h3 className="slot_Heading">Clinic Timings</h3>
            <span className="add-slot">
              <AccessTimeIcon /> Add Slot
            </span>
          </div>
          {/* <div className="clinic-details_slot-section-container">
            <div className="day-column">
              {Object.keys(slotsByDay).map((day) => (
                <span key={day} className="day-box">{day}</span>
              ))}
            </div>
            <div className="time-slot-column">
              {Object.keys(slotsByDay).map((day) => (
                <div key={day} className="morning-time-column">
                  {slotsByDay[day].map((slot, index) => (
                    <span key={`${day}-${slot.startTime.hour}-${slot.startTime.minute}`} className="time-box">
                      {`${slot.startTime.hour}:${slot.startTime.minute.toString().padStart(2, '0')} - ${slot.endTime.hour}:${slot.endTime.minute.toString().padStart(2, '0')}`}
                      <CloseIcon className="available-slot-cross_icon" onClick={() => removeAvailableSlotCapsule(slot, day)} />
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div> */}
          <div className="slots-grid">
            {Object.keys(slotsByDay).map((day) => (
              <div key={day} className="day-grid-column">
                <div className="day-box">{day}</div>

                {slotsByDay[day]?.map((slot) => (
                  <div
                    key={`${day}-${slot.startTime.hour}-${slot.startTime.minute}`}
                    className="time-box"
                  >
                    {`${slot.startTime.hour}:${slot.startTime.minute
                      .toString()
                      .padStart(2, "0")} - ${slot.endTime.hour}:${slot.endTime.minute
                        .toString()
                        .padStart(2, "0")}`}

                    <CloseIcon
                      className="available-slot-cross_icon"
                      onClick={() => removeAvailableSlotCapsule(slot, day)}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>


        </div>
      </div>
      {/* <hr className="horizintal-line-clinic-details-card" />
      <div className="avilableDoctor_container-main">
        <h3 className="avilable-doctor-heading">Available Doctor</h3>
        <span
          className="avilable-doctor_add-button"
          onClick={() => setAddDoctorPopup(true)}
        >
          <AddIcon /> Add New Doctors
        </span>
      </div>

      <div className="clini-details-doctor_container">
        {doctor.map((item, index) => (
          <div className="clinic-details_doctor-box" key={index}>
            <div className="doctor-image-container">
              <img src={item.doctorImage || "https://img.freepik.com/premium-photo/medical-concept-indian-beautiful-female-doctor-white-coat-with-stethoscope-waist-up-medical-student-woman-hospital-worker-looking-camera-smiling-studio-blue-background_185696-621.jpg?w=1060"} alt="drImage" />
            </div>
            <div className="doctor-text">
              <h3 className="doctor-name">{item.name.firstName + " " + item.name.middleName + " " + item.name.lastName}</h3>
              <p className="doctor-specialization">
                {item.specilizations}
              </p>
              <Select
                className="Online-Offline_selector"
                defaultValue={selectedOption}
                onChange={setSelectedOption}
                options={options}
              />
            </div>
            <CloseIcon className="remove-doctor-icon" onClick={() => handleRemoveDoctor(index, item._id)} />
          </div>
        ))}
      </div>
      <hr className="horizintal-line-clinic-details-card" />
      <div className="avilableDoctor_container-main">
        <h3 className="avilable-doctor-heading">Assistants</h3>
        <span
          className="avilable-doctor_add-button"
          onClick={() => setAddAssistantPopup(true)}
        >
          <AddIcon /> Add Assistant
        </span>
      </div>

      <div className="clini-details-doctor_container">
        {assistants.map((item, index) => (
          <div className="clinic-details_doctor-box" key={index}>
            <div className="doctor-image-container">
              <img src={item.assistantImage} alt="assistantImage" />
            </div>
            <div className="doctor-text">
              <h3 className="doctor-name">{item.assistantName}</h3>
              <p className="doctor-specialization">
                {item.assistantSpecialization}
              </p>
              <Select
                className="Online-Offline_selector"
                defaultValue={selectedOption}
                onChange={setSelectedOption}
                options={options}
              />
            </div>
            <CloseIcon className="remove-doctor-icon" onClick={() => handleRemoveAssistant(index)} />
          </div>
        ))}
      </div> */}

      {/* ADD SLOT POP-UP RENDER HERE */}
      {addSlotPopUp && <AddSlot setAddSlotPopUp={setAddSlotPopUp} selectedClinic={selectedClinic} />}
      {/* ADD DOCTOR POP-UP RENDER HERE */}
      {addDoctorPopup && (
        <AddDoctorPopup setAddDoctorPopup={setAddDoctorPopup} onSubmit={handleAddDoctor} />
      )}
      {/* ADD ASSISTANT POP-UP HERE */}
      {addAssistantPopup && (
        <AddAssistantPopup setAddAssistantPopup={setAddAssistantPopup} onSubmit={handleAddAssistant} />
      )}
      {/* SHOW IMAGE POP-UP REANDER HERE */}
      {showMoreImages && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => setShowMoreImages(false)}>
              &times;
            </span>
            <div className="modal-images">
              {additionalImages.map((image, index) => (
                <div className="image-container" key={index}>
                  <img
                    src={image}
                    alt={`Additional ${index + 1}`}
                    onClick={() => openFullScreenImage(index)}
                  />
                  <CloseIcon
                    className="remove-icon"
                    onClick={() => removeImage(index)}
                  />
                </div>
              ))}
              <div className="image-container add-image-container">
                <input
                  type="file"
                  accept="image/*"
                  onChange={addImage}
                  className="add-image-input"
                />
                <AddIcon className="add-icon" />
              </div>
            </div>
          </div>
        </div>
      )}
      {fullScreenImageIndex !== null && (
        <div className="fullscreen-modal">
          <div className="fullscreen-modal-content">
            <span className="close" onClick={closeFullScreenImage}>
              &times;
            </span>
            <img
              src={additionalImages[fullScreenImageIndex]}
              alt="Full Screen"
            />
            <button className="prev-button" onClick={showPreviousImage}>
              &lt;
            </button>
            <button className="next-button" onClick={showNextImage}>
              &gt;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClinicDetailsCard;

